import { RealtimeModal } from "../../components/modal/RealtimeModal"
import { EventValueEnum } from "../../types/communication/communicationDataType"
import { tqPageView } from "../../utils/utils"
import { CancelAuthorizeConfirmClaimModalContent } from "./CancelAuthorizeConfirmClaimModalContent"

interface AuthConfirmCancelProcedureModalProps {
    modalOpened: boolean
    onCloseHandler?: any
    event?: EventValueEnum
    companyName?: string
}

const AuthConfirmCancelProcedureModal = (props: AuthConfirmCancelProcedureModalProps) => {
    const { modalOpened, onCloseHandler, event, companyName } = props

    const onCurrentModalCloseHandler = () => {
        /* istanbul ignore next */
        onCloseHandler && onCloseHandler()
    }

    return <>
        <RealtimeModal
            companyName={companyName}
            modalOpened={modalOpened}
            hTitle={companyName !== "LINEAR" ? "Informazioni mancanti" : "ABBANDONA PROCEDURA"}
            hCloseButton={true}
            onCloseHandler={onCurrentModalCloseHandler}
            onOpenHandler={() => {
                 /* istanbul ignore next */
                companyName !== "LINEAR" && tqPageView('cai:cai:documento di riconoscimento:info mancante')
            }}>
            <CancelAuthorizeConfirmClaimModalContent
                additionalData={{ event }} />
        </RealtimeModal>
    </>
}

export default AuthConfirmCancelProcedureModal